module.exports = __webpack_public_path__ + "static/img/img03.7148b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c39/img03.png
// module id = t5NS
// module chunks = 0